<template>
  <div class="block"  :style='blockStyle'>
  </div>
</template>

<script>
export default {
  name: "block",
  props: {
    width: {
      default: "100%"
    },
    height: {
      default: "30px"
    },
    padding: {
      default: "20px" // left center right
    },
  },
  computed: {
    blockStyle() {
      return {
        width: this.width,
        height: this.height
      };
    }
  },
  data() {
    return {
      orgActiveStyle: {},
      orgStyle: {},
      defaultActiveStyle: {
        background: this.plain ?'none':"rgba(24, 145, 238, 1)",
        color: "#fff"
      },
      defaultStyle: {
        borderRadius: "2px",
        color: "#289eff",
        border: this.plain ?'none': "1px solid rgba(24, 145, 238, 1)"
      },
      btnIdx: 0
    };
  },
  // watch: {
  //   btnList: {
  //     handler() {},
  //     deep: true
  //   }
  // },
  

  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.orgActiveStyle = { ...this.defaultActiveStyle, ...this.activeStyle };
      console.log(this.orgActiveStyle, "this.orgActiveStyle====");
      this.orgStyle = { ...this.defaultStyle, ...this.itemStyle };
      //console.log(this.orgStyle, "this.orgStyle====");
    }
    
  }
};
</script>
<style scoped lang="scss">
// parallelogram:平行四边形；round:椭圆；line:线；square:长方形；
.button-group {
  .parallelogram {
    -webkit-transform: skewX(-20deg);
    -moz-transform: skewX(-20deg);
    transform: skewX(-20deg);
    span {
      -webkit-transform: skewX(20deg);
      -moz-transform: skewX(20deg);
      transform: skewX(20deg);
      display: inline-block;
    }
  }
  .round {
    div {
      border-radius: 40px !important;
    }
  }
  .circle {
    div {
      border-radius: 50%  !important;
    }
  }
  .waterline {
    div {
      // background: none !important;
      // border: none !important;
    }
  }
  .square {
  }
  ul {
    list-style: none;
    height: 100%;
  }
  ul li {
    height: 100%;
    cursor: pointer;
    text-align: center;
    display: inline-block;
  }
  ul li > div {
    min-width: 30px;
  }
}
</style>